import { Stack, TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../components/button/CustomButton';
import ForgotPasswordModal from './components/ForgotPasswordModal';
import useCreate from '../../../utils/hooks/crud-hooks/useCreate';

const ForgotPasswordSection = () => {
  const [showResetPassword, setShowResetPassword] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const { t } = useTranslation();
  const { mutate } = useCreate<Record<string, unknown>, Record<string, unknown>>({
    resource: '/auth/reset-password',
  });

  function handleClick() {
    setShowResetPassword(true);
    mutate(
      { email },
      {
        onSuccess: () => {
          setEmailSent(true);
        },
      },
    );
  }

  return (
    <>
      <ForgotPasswordModal
        open={showResetPassword}
        closeModal={() => setShowResetPassword(false)}
      />

      <Stack width="100%" spacing={4}>
        <Typography
          variant="headline1"
          sx={{
            color: 'primaryDark.600',
          }}
        >
          {t('security.forgotPassword')}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'primaryDark.600',
          }}
        >
          {t('security.sendUsPasswordResetRequest')}
        </Typography>

        <Stack
          direction="column"
          width="100%"
          sx={{ mt: '2.5rem !important', mb: '1rem !important' }}
          spacing={1}
        >
          <Typography
            sx={{ textTransform: 'uppercase', fontFamily: 'Gellix-SemiBold', color: '#79829B' }}
          >
            {t('common.email')}
          </Typography>

          <TextField
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setEmail(e.target.value);
            }}
            value={email}
            placeholder={t('security.enterYourEmail')}
            fullWidth
            variant="outlined"
          />
        </Stack>

        <CustomButton
          sx={{
            alignSelf: 'flex-end',
            width: 'fit-content !important',
          }}
          onClick={() => handleClick()}
          disabled={!email}
        >
          {t('security.resetPassword')}
        </CustomButton>
      </Stack>
    </>
  );
};

export default ForgotPasswordSection;
